import { render, staticRenderFns } from "./QuoteView.vue?vue&type=template&id=2a8ec124&scoped=true"
import script from "./QuoteView.vue?vue&type=script&lang=js"
export * from "./QuoteView.vue?vue&type=script&lang=js"
import style0 from "./QuoteView.vue?vue&type=style&index=0&id=2a8ec124&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ec124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8ec124')) {
      api.createRecord('2a8ec124', component.options)
    } else {
      api.reload('2a8ec124', component.options)
    }
    module.hot.accept("./QuoteView.vue?vue&type=template&id=2a8ec124&scoped=true", function () {
      api.rerender('2a8ec124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteView.vue"
export default component.exports